<nb-card>
    <nb-card-header class="d-flex justify-content-end">
        <button nbButton status="basic" (click)="onClose()">
            <nb-icon icon="close-outline"></nb-icon>
        </button>
    </nb-card-header>
    <nb-card-body>
        <nb-stepper disableStepNavigation #stepper>
            <nb-step>
                <p class="paragraph text-center">
                    <strong>{{ "GENERAL.ALL-SET" | translate }}</strong> <br />
                    {{ "TOKEN-REQUEST.SUBSCRIPTION" | translate }}
                </p>
                <app-token-request
                    [player]="player"
                    [extra]="{ tournament_id: tournamentId, category_id: categoryId }"
                    (sent)="onTokenSent($event)"
                    type="2"
                    *ngIf="player"
                ></app-token-request>
            </nb-step>
            <nb-step>
                <app-token-validate
                    type="2"
                    [player]="player"
                    [extra]="{ tournament_id: tournamentId, category_id: categoryId }"
                    [codeToken]="codeToken"
                    [typeSending]="typeSending"
                    (validate)="onValidationSuccess($event)"
                    *ngIf="stepper.selectedIndex === 1 && codeToken"
                ></app-token-validate>
            </nb-step>
        </nb-stepper>
    </nb-card-body>
</nb-card>
